<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/franken/rudolf-furst')">Rudolf Furst
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">German Fine Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Come produttore di vini di alta qualità, la Germania è una macchina ben oliata. La sua attrezzatura e
                        l'amministrazione è l'invidia del mondo, i suoi numeri assegnati con precisione rendono facile ogni lotto
                        find e i suoi livelli di zucchero residuo sono misurati con semplicità. I suoi Riesling secchi sono il
                        benchmark a cui aspirano altri paesi. Le sue leggi sull'etichettatura sono tra le più complete
                        e completo (per non parlare di confusione) nel mondo. E in termini di investibilità
                        opzioni, il suo potenziale è alle stelle.
                        <br><br>
                        Per comprendere appieno perché i vini tedeschi sono decollati come investimento fattibile dal 2016
                        (un incredibile aumento del 576% rispetto al 2015), dobbiamo prima cercare di capire la storia che cambia
                        delle sue regioni vinicole. Quella che una volta era stata un'industria che si vantava della sua ingegneria
                        l'eccellenza era caduta in disgrazia nel circuito del vino pregiato e languiva dietro il suo europeo
                        vicini del dopoguerra. Ciò è dovuto principalmente all'uniformizzazione dei vini negli anni '70 che
                        ha decretato che per qualificarsi per l'ambito "Qualitätswein bestimmter Anbaugebiete" (QbA)
                        classificazione (simile alla classificazione Grand Cru o A.O.C. di Francia), i vini dovevano essere dolci (più dolce è il
                        meglio) quindi tutto ciò che i produttori hanno fatto è stato aumentare la percentuale di uve ultra mature. Ciò significava l'esportazione
                        i vini della Germania sono diventati sinonimo di produttori come Blue Nun e Liebfraumilch. Anche
                        significava che l'uva stella tedesca difficile da maturare - Reisling - ha perso.
                        <br><br>
                        Per fortuna questo ha cominciato a cambiare a metà degli anni '80. Una nuova generazione di appassionati di vinificazione
                        a chi non importava del QbA ha iniziato a limitare le rese e a fermentare in rovere invece di
                        i tradizionali tini in acciaio inossidabile dei loro antenati. Anche il riscaldamento globale ha fatto la sua parte
                        e le estati più calde hanno permesso ai produttori di sperimentare Pinot Nero e in alcuni casi Syrah e
                        Cabernet Sauvignon. Questi cambiamenti hanno dato origine agli stili secchi che costituiscono il 70% della multa tedesca
                        vino oggi. Secondo Jancis Robinson, il paese è responsabile di “alcuni problemi del mondo
                        i bianchi più leggeri, più fini, più longevi e alcuni rossi sempre più rispettabili”.
                        <br><br>
                        Tuttavia, è, ovviamente, l'uva Riesling destinata alla grandezza in Germania. Suo
                        l'acidità naturalmente elevata consente un invecchiamento praticamente illimitato (fino a 100 anni in alcuni casi se
                        correttamente invecchiato), mentre il suo delicato aroma floreale e fruttato lo rende uno dei preferiti da bere
                        (sebbene le nobili varietà dolci del Riesling tedesco siano state difficili da vendere negli Stati Uniti
                        States, un pubblico che in genere predilige un vino secco). Le regioni possono essere ridotte a
                        tre tipi diversi: il buono (Mosel), il non proprio buono (Rhinegau), il grosso
                        (Rheinhessen) e quello da tenere d'occhio (Ahr).
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">German Fine Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Als Produzent hochwertiger Weine ist Deutschland eine gut geölte Maschine. Seine Ausstattung und
                        Die Verwaltung wird von der ganzen Welt beneidet, ihre präzise zugewiesenen Nummern machen jede Charge einfach zu handhaben
                        gefunden und der Restzuckergehalt lässt sich einfach messen. Seine trockenen Rieslinge sind die
                        Maßstab, den andere Länder anstreben. Seine Kennzeichnungsgesetze gehören zu den umfassendsten
                        und umfassend (ganz zu schweigen davon, verwirrend) in der Welt. Und im Hinblick auf die Investitionsfähigkeit
                        Optionen, sein Potenzial geht durch die Decke.
                        <br><br>
                        Um vollständig zu verstehen, warum deutsche Weine seit 2016 eine lohnende Investition sind
                        (ein unglaublicher Anstieg von 576 % gegenüber 2015), müssen wir zunächst versuchen, die sich verändernde Geschichte zu verstehen
                        seiner Weinregionen. Einst eine Industrie, die stolz auf ihre Ingenieurskunst war
                        Exzellenz war in der Weinszene der edlen Weine in Ungnade gefallen und blieb hinter ihrer europäischen zurück
                        Nachbarn nach dem Krieg. Dies war vor allem auf die Vereinheitlichung der Weine in den 1970er Jahren zurückzuführen
                        verfügte, dass für die Qualifikation zum begehrten „Qualitätswein bestimmter Anbaugebiete“ (QbA)
                        In der Rangliste (ähnlich der französischen Grand Cru- oder A.O.C.-Bewertung) mussten die Weine süß sein (je süßer der
                        besser), also haben die Erzeuger lediglich den Anteil ultrareifer Trauben erhöht. Damit war der Export gemeint
                        Weine aus Deutschland wurden zum Synonym für Produzenten wie Blue Nun und Liebfraumilch. Es auch
                        Dies führte dazu, dass Deutschlands schwer zu reifende Sterntraube, der Reisling, den Kürzeren zog.
                        <br><br>
                        Glücklicherweise begann sich dies Mitte der 1980er Jahre zu ändern. Eine neue Generation von Weinliebhabern
                        Wem das QbA egal war, begann, die Erträge zu begrenzen und stattdessen in Eichenfässern zu gären
                        die traditionellen Edelstahltanks ihrer Vorfahren. Auch die globale Erwärmung hat ihren Teil dazu beigetragen
                        und wärmere Sommer ermöglichten es den Produzenten, mit Pinot Noir und in einigen Fällen Syrah zu experimentieren
                        Cabernet Sauvignon. Durch diese Veränderungen entstanden die trockenen Stile, die 70 % des deutschen Feines ausmachen
                        Wein heute. Laut Jancis Robinson ist das Land für „einige der weltweiten Probleme“ verantwortlich
                        die hellsten, feinsten und langlebigsten Weißweine und einige zunehmend respektable Rotweine.“
                        <br><br>
                        Aber es ist natürlich die Riesling-Traube, die in Deutschland Großes erreichen wird. Es ist
                        Der natürlich hohe Säuregehalt ermöglicht eine praktisch unbegrenzte Reifung (in manchen Fällen bis zu 100 Jahre).
                        richtig gelagert), während sein zartes blumiges, fruchtiges Aroma ihn zu einem Lieblingsgetränk macht
                        (obwohl die edelsüßen Sorten des deutschen Rieslings in den Vereinigten Staaten schwer zu verkaufen waren
                        Staaten, ein Publikum, das im Allgemeinen einen trockenen Wein bevorzugt). Die Regionen können auf das Wesentliche reduziert werden
                        drei verschiedene Typen: Die Guten (Mosel), die Nicht ganz so Guten (Rheingau), die Masse
                        (Rheinhessen) und der zum Anschauen (Ahr).
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">German Fine Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        En tant que producteur de vins de grande qualité, l'Allemagne est une machine bien huilée. Son équipement et
                        l'administration fait l'envie du monde, ses numéros précisément attribués rendent chaque lot facile à
                        trouver et ses taux de sucre résiduels sont mesurés avec simplicité. Ses Rieslings secs sont les
                        référence à laquelle d'autres pays aspirent. Ses lois sur l'étiquetage sont l'une des plus complètes
                        et complet (pour ne pas dire déroutant) dans le monde. Et en termes d'investissabilité
                        options, son potentiel est à travers le toit.
                        <br><br>
                        Afin de bien comprendre pourquoi les vins allemands sont devenus un investissement viable depuis 2016
                        (une augmentation incroyable de 576% par rapport à 2015), il faut d'abord essayer de comprendre l'évolution de l'histoire
                        de ses régions viticoles. Ce qui était autrefois une industrie fière de son ingénierie
                        l'excellence était tombée en disgrâce sur le circuit des grands vins et languissait derrière son marché européen
                        voisins d'après-guerre. Cela est principalement dû à l'uniformisation des vins dans les années 1970 qui
                        a décrété que pour se qualifier pour la très convoitée « Qualitätswein bestimmter Anbaugebiete » (QbA)
                        classement (similaire au classement Grand Cru ou A.O.C. français), les vins devaient être doux (plus le
                        mieux) donc tous les producteurs ont augmenté le pourcentage de raisins ultra-mûrs. Cela signifiait l'exportation
                        les vins d'Allemagne sont devenus synonymes de producteurs tels que Blue Nun et Liebfraumilch. Ça aussi
                        signifie que le cépage star allemand difficile à mûrir - Reisling - a perdu.
                        <br><br>
                        Heureusement, cela a commencé à changer au milieu des années 1980. Une nouvelle génération de passionnés de vin
                        qui ne se souciaient pas du QbA ont commencé à limiter les rendements et à fermenter en fût de chêne au lieu de
                        les traditionnelles cuves inox de leurs ancêtres. Le réchauffement climatique a aussi joué son rôle
                        et des étés plus chauds ont permis aux producteurs d'expérimenter le pinot noir et, dans certains cas, la syrah et
                        Cabernet Sauvignon. Ces changements ont donné naissance aux styles secs qui constituent 70 % de l'amende allemande.
                        vin aujourd'hui. Selon Jancis Robinson, le pays est responsable de « certaines des
                        les blancs les plus légers, les plus beaux et les plus vivants et des rouges de plus en plus respectables ».
                        <br><br>
                        Cependant, c'est bien sûr le cépage Riesling qui est destiné à la grandeur en Allemagne. C'est
                        une acidité naturellement élevée permet un vieillissement quasi illimité (jusqu'à 100 ans dans certains cas si
                        correctement en cave), tandis que son délicat arôme floral et fruité en fait un favori pour boire
                        (bien que les variétés douces nobles du Riesling allemand aient été difficiles à vendre aux États-Unis
                        States, un public qui préfère en général un vin sec). Les régions peuvent se résumer à
                        trois types différents: le bon (Moselle), le moins bon (Rhinegau), le vrac
                        (Rheinhessen) et celle à surveiller (Ahr).
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">German Fine Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        As a producer of high-quality wines, Germany, is a well-oiled machine. Its equipment and
                        administration is the envy of the world, its precisely assigned numbers make every batch easy to
                        find and its residual sugar levels are measured with simplicity. Its dry Rieslings are the
                        benchmark to which other countries aspire to. Its labelling laws are one of the most complete
                        and comprehensive (not to mention confusing) in the world. And in terms of investability
                        options, its potential is through the roof.
                        <br><br>
                        In order to fully understand why German wines have taken off as a viable investment since 2016
                        (an unbelievable 576% increase on 2015), we must first try and understand the changing history
                        of its wine regions. What had once been an industry that prided itself on its engineering
                        excellence had fallen out of favour on the fine wine circuit, and languished behind its European
                        neighbours post-War. This was mainly due to the uniformisation of wines in the 1970s that
                        decreed that in order to qualify for the coveted “Qualitätswein bestimmter Anbaugebiete” (QbA)
                        ranking (similar to France’s Grand Cru or A.O.C. rating), wines had to be sweet (the sweeter the
                        better) so all producers did was up the percentage of ultra-ripe grapes. This meant the export
                        wines of Germany became synonymous with producers such as Blue Nun and Liebfraumilch. It also
                        meant that Germany’s difficult to ripen star grape - Reisling - lost out.
                        <br><br>
                        Thankfully this began to change in the mid-1980s. A new generation of wine producing enthusiasts
                        who didn&#39;t care about the QbA started limiting yields and fermenting in oak as opposed to
                        the traditional stainless steel vats of their ancestors. Global warming has played its part too
                        and warmer summers allowed producers to experiment with Pinot Noir and in some cases Syrah and
                        Cabernet Sauvignon. These changes gave rise to the dry styles that make up 70% of German fine
                        wine today. According to Jancis Robinson, the country is responsible for “some of the world’s
                        lightest, finest, longest living whites and some increasingly respectable reds”.
                        <br><br>
                        However, it is, of course, the Riesling grape that is destined for greatness in Germany. It’s
                        naturally high acidity allows for practically limitless ageing (up to 100 years in some cases if
                        properly cellared), while its delicate floral, fruity aroma makes it a favourite for drinking
                        (although the noble sweet varieties of German Riesling have been hard to sell in the United
                        States, an audience which in general prefers a dry wine). The regions can be boiled down to
                        three different types: The good (Mosel), the not-quite-so-good (Rhinegau), the bulk
                        (Rheinhessen) and the one to watch (Ahr).
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Franken",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Rudolf Furst', src: '/wine-guide/germany/franken/rudolf-furst'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Franken fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the hidden gems of German wine-making in the Franken wine region. From crisp and fruity whites to full-bodied reds, experience the unique flavors of this historic region. Explore the diverse range of wines produced by top winemakers such as Jean Stodden.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
